import { createApp } from 'vue'
import VueSweetalert2 from "vue-sweetalert2";
import App from "./App.vue";
import store from "./store/index.js";
import vuetify from "./plugins/vuetify.js";
import { KeyCloakService, keycloakInstance } from "@/plugins/authentication.js";
import router from "./router/router.js";
import "@/styles/main.css";

import "sweetalert2/dist/sweetalert2.min.css";

const renderApp = () => {
	createApp(App)
		.use(vuetify)
		.use(router)
		.use(VueSweetalert2)
		.use(store)
		.provide("$keycloak", keycloakInstance)
		.mount("#app");
};

KeyCloakService.CallLogin(renderApp);
